function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ga, mixpanel } from '@domain-group/fe-co-allhomes-analytics';
var tabNames = {
  sales: 'Sale',
  rentals: 'Rent',
  sold: 'Sold'
};
var sourceMap = {
  agents: 'Agent Icons',
  agency: 'Header',
  footer: 'Footer',
  'mobile-enquiry-cta': 'Footer'
};
var AGENCY_PROFILE = 'Agency Profile';
var RATE_MY_AGENT = 'Ratemyagent Agency Profile';
var AGENCY_PROFILE_HEADER = 'Agency Profile - Header';
var AGENCY_PROFILE_MAP_CARD = 'Agency Profile - Map Card';
var AGENCY_PROFILE_FLOATING_CTA = 'Agency Profile - Floating CTA';
var AGENCY_PROFILE_OUR_TEAM = 'Agency Profile - Our Team';
var source = key => sourceMap[/^([^.]*)\./.exec(key)[1]];
var label = key => {
  if (key.startsWith('mobile-enquiry-cta')) {
    return AGENCY_PROFILE_FLOATING_CTA;
  }
  if (source(key) === sourceMap.footer) {
    return AGENCY_PROFILE_MAP_CARD;
  }
  if (source(key) === sourceMap.agency) {
    return AGENCY_PROFILE_HEADER;
  }
  return AGENCY_PROFILE_OUR_TEAM;
};
export default {
  'page-view': () => mixpanel.viewAgencyProfilePage(),
  '/\\.call-reveal$/': key => _objectSpread(_objectSpread({}, ga.conversion('Click to Reveal - Find an Agent', "Agency Profile - ".concat(source(key)))), mixpanel.revealPhone({
    enquiryCTA: label(key)
  })),
  '/\\.email-click$/': key => _objectSpread(_objectSpread({}, ga.interaction(AGENCY_PROFILE, "Open Email Lightbox - ".concat(source(key)))), mixpanel.displayContactAgentForm({
    enquiryCTA: label(key)
  })),
  '/(agency|footer)\\.website-click$/': key => ga.interaction(AGENCY_PROFILE, "Agency Website Click - ".concat(source(key))),
  'agency.show-more': () => ga.interaction(AGENCY_PROFILE, 'Expand About Agency'),
  'agents.agent-card.card-click': () => ga.interaction(AGENCY_PROFILE, 'Agent Picture Icons'),
  'listing-card-tabs.show-more': () => ga.interaction(AGENCY_PROFILE, 'Show All'),
  'listing-card-tabs.tab-select': (key, _ref) => {
    var tab = _ref.tab;
    return ga.interaction(AGENCY_PROFILE, "Listings Tab - ".concat(tabNames[tab]));
  },
  'listing-card.card-click': (key, _ref2) => {
    var tab = _ref2.tab;
    return ga.interaction(AGENCY_PROFILE, "Property Click - ".concat(tabNames[tab]));
  },
  'send-enquiry': (key, _ref3) => {
    var options = _ref3.options;
    return _objectSpread(_objectSpread({}, ga.conversion('Email Enquiry - Find an Agent', 'Agency Profile')), mixpanel.emailEnquiry({
      enquiryReasons: options
    }));
  },
  'next-review': () => ga.interaction(RATE_MY_AGENT, 'Display Next Review'),
  'previous-review': () => ga.interaction(RATE_MY_AGENT, 'Display Previous Review'),
  'expand-review': () => ga.interaction(RATE_MY_AGENT, 'Expand Review'),
  'open-review-profile': () => ga.interaction(RATE_MY_AGENT, 'View Ratemyagent Page'),
  'footer.map-activity': () => ga.interaction(AGENCY_PROFILE, 'Map Interaction'),
  '/agency-articles.article-click/': () => ga.conversion('Editorial Showcase', 'Agency Profile - Article - Click')
};